import { Button, DialogContent, Grid, Paper } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import React, { useEffect, useState } from "react"
import { localeBRDataGridText } from "../utils/data-grid-local-text"
import PropTypes from 'prop-types'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DescriptionIcon from '@mui/icons-material/Description'
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined'
import { formatDateDataGrid } from "../utils/format-date"
import Loading from "./loading"
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"
import ConfirmDialog from "./confirm-dialog"
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded'
import UploadFileModalComponent from "./upload-file-modal-component"
import NewspaperIcon from '@mui/icons-material/Newspaper'
import RegisterDocumentService from "../services/register-document-service"
import { TokenService } from "../services/token-service"
import ToggleButtonSelect from "./toggle-button-select"
import { Dialog } from '@mui/material'


const PAGE_DEFAULT_SIZE = 25

const MEDIA_FILE_TYPE = {
    '.csv': {
        icon: <TableRowsOutlinedIcon />, color: '#4caf50', mediaType: 'text/csv'
    }, '.pdf': {
        icon: <PictureAsPdfIcon />, color: '#e53935', mediaType: 'application/pdf'
    }, '.doc': {
        icon: <DescriptionIcon />, color: '#1976d2', mediaType: 'application/msword'
    }, '.docx': {
        icon: <DescriptionIcon />,
        color: '#1976d2',
        mediaType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }, '.xlsx': {
        icon: <TableRowsOutlinedIcon />,
        color: '#2e7d32',
        mediaType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }, '.xls': {
        icon: <TableRowsOutlinedIcon />, color: '#2e7d32', mediaType: 'application/vnd.ms-excel'
    }, '.pptx': {
        icon: <NewspaperIcon />, // ou outro mais específico como SlideshowIcon, se disponível
        color: '#e45f0f', mediaType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    }, '.ppt': {
        icon: <NewspaperIcon />, color: '#e45f0f', mediaType: 'application/vnd.ms-powerpoint'
    }
}

const DocumentosTableComponent = ({ diretorio, pasta, callbackAlert, enableUpload }) => {
    const documentService = new RegisterDocumentService()
    const [rows, setRows] = useState([])
    const [load, setLoad] = useState(false)
    const [modalUploadClose, setModalUploadClose] = useState(false)
    const [dialogDeleteFile, setDialogDeleteFile] = useState({
        open: false, file: null, title: "Deseja realmente excluir o arquivo ?"
    })
    const [userAdmin, setUserAdmin] = useState(false)
    const tokenService = new TokenService()

    useEffect(() => {
        const userIsAdmin = tokenService.verifyUserIsAdmin()
        setUserAdmin(userIsAdmin)


        loadDirectoryFiles()
    }, [diretorio, pasta])

    const downloadFile = (file, nomeArquivo, url) => {
        const contentDisposition = file.headers['content-disposition']
        let filename = nomeArquivo
        const match = /filename="(.+?)"/.exec(contentDisposition)
        if (match) {
            filename = match[1]
        }

        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
    }

    const handleFileClick = (row) => {
        const { ID, Arquivo, Origem, Diretorio } = row

        setLoad(true)
        documentService.openFileFromDirectory(ID, Diretorio, Origem, Arquivo)
            .then((response) => {
                const contentType = response.headers['content-type']
                const blob = new Blob([response.body], { type: contentType })
                const url = window.URL.createObjectURL(blob)
                const tiposVisualizaveis = ['application/pdf',]
                if (tiposVisualizaveis.includes(contentType)) {
                    setFileUrl(url)
                    setOpen(true)
                    return
                }
                return downloadFile(response, Arquivo, url)
            })
            .catch(() => {
            })
            .finally(() => {
                setLoad(false)
            })
    }

    const deleteFile = () => {
        const { arquivo, origem, diretorio } = dialogDeleteFile
        setLoad(true)

        documentService.deleteFile(diretorio, origem, arquivo)
            .then(() => {
                callbackAlert("success", "Arquivo removido")
                loadDirectoryFiles()
            })
            .catch(() => {
                callbackAlert("error", "Erro ao remover o arquivo")
                setLoad(false)
            })
    }

    const openDeleteRow = (params) => {
        const { row: { Arquivo, Origem, Diretorio } } = params
        setDialogDeleteFile({ ...dialogDeleteFile, open: true, arquivo: Arquivo, origem: Origem, diretorio: Diretorio })
    }

    const uploadFile = (fileToUpload) => {
        if (diretorio === null || pasta === null) {
            callbackAlert("error", "Diretorio ou pasta não informado")
            return
        }

        const { file, accessType, filename } = fileToUpload
        const extension = file?.name?.split('.').pop()?.toLowerCase()
        const { mediaType } = MEDIA_FILE_TYPE[extension] || {}

        if (mediaType === null) {
            callbackAlert("warning", `Tipo de arquivo ${extension} não suportado`)
            return
        }

        setLoad(true)
        documentService.registerDocument(diretorio, pasta, accessType, filename, file)
            .then(() => {
                callbackAlert("success", `${name} carregado com sucesso`)
                loadDirectoryFiles()
            })
            .catch((err) => {
                const payload = JSON.stringify(err)
                const json = JSON.parse(payload)
                const { response: { body } } = json
                callbackAlert("warning", body)
                setLoad(false)
            })
    }

    const loadDirectoryFiles = () => {
        const cetipPart = pasta ? pasta.split('/')[1] : null

        if (!cetipPart || cetipPart === 'null' || cetipPart === 'undefined') {
            setRows([])
            setLoad(false)
            return
        }
        setLoad(true)
        documentService.getFilesFromDirectoryFolder(diretorio, pasta)
            .then((response) => {
                console.log("RESPONSE:", response)
                const jsonString = response.text

                const parsedData = JSON.parse(jsonString)
                if (Array.isArray(parsedData)) {
                    callbackAlert("warning", "CETIP não cadastrado/não liberado o acesso. Entre em contato com o Administrador")
                    setRows([])
                    return
                }

                if (parsedData && parsedData.data) {
                    const list = parsedData.data.map((obj, index) => ({ ...obj, id: index }))
                    setRows(list)
                } else {
                    console.log("FALHOU")
                    throw new Error("Resposta inválida do servidor.")
                }
            })
            .catch((error) => {
                console.log("FALHOU:", error)
                callbackAlert("error", "Não foi possível carregar os documentos")
            })
            .finally(() => {
                setLoad(false)
            })
    }

    const renderDocument = (params) => {
        const { row } = params
        const { Arquivo } = row

        const extensao = Arquivo.slice(Arquivo.lastIndexOf('.')).toLowerCase()
        const fileInfo = MEDIA_FILE_TYPE[extensao] || {}
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => handleFileClick(row)}
            >
                {fileInfo.icon && (<span style={{ color: fileInfo.color }}>{fileInfo.icon}</span>)}
                <span>{Arquivo}</span>
            </div>)
    }

    const updateDocumentType = (id, value) => {
        let type = value ? "PRIVATE" : "PUBLIC"

        setLoad(true)
        documentService.updateDocumentTypeAccess(id, type)
            .then(() => {
                callbackAlert("success", "Acesso atualizado com sucesso")
            })
            .catch(() => {
                callbackAlert("error", "Erro ao atualizar o acesso do arquivo")
                loadDirectoryFiles()
            })
            .finally(() => {
                setLoad(false)
            })
    }

    const renderTypeAccess = (params) => {
        const { ID, TipoAcesso } = params.row
        const tipo = (TipoAcesso || '').toUpperCase()
        const isPrivate = tipo === 'PRIVATE'

        if (tipo !== 'PUBLIC' && tipo !== 'PRIVATE') {
            return <span style={{ color: 'gray' }}>Tipo inválido</span>
        }

        return (<ToggleButtonSelect
            key={ID + '-' + tipo}
            leftLabel="Público"
            rightLabel="Privado"
            value={isPrivate}
            onChange={(newValue) => updateDocumentType(ID, newValue)}
        />)
    }

    const [fileUrl, setFileUrl] = useState(null)
    const [open, setOpen] = useState(false)

    return <>
        <Loading show={load} />

        {userAdmin ? <Grid container direction={"row"} alignItems={"flex-end"} justifyContent={"flex-end"}>
            <Grid item>
                <Button
                    color="primary"
                    variant="outlined"
                    disabled={!enableUpload}
                    startIcon={<CloudUploadRoundedIcon />}
                    onClick={() => setModalUploadClose(true)}>
                    Upload de Documento
                </Button>
            </Grid>
        </Grid> : <></>}

        <br />
        <Paper>
            <DataGrid
                autoHeight
                columns={[{
                    headerName: "Documento",
                    field: "Arquivo",
                    flex: true,
                    minWidth: 250,
                    renderCell: (params) => renderDocument(params)
                }, userAdmin && {
                    headerName: "Tipo de Acesso",
                    field: "TipoAcesso",
                    flex: true,
                    minWidth: 250,
                    maxWidth: 250,
                    renderCell: (params) => renderTypeAccess(params)
                }, {
                    headerName: "Criado Em",
                    field: "CriadoEm",
                    flex: true,
                    minWidth: 200,
                    maxWidth: 200,
                    renderCell: (params) => formatDateDataGrid(params)
                }, userAdmin && {
                    headerName: "Excluir",
                    field: "Excluir",
                    minWidth: 100,
                    maxWidth: 100,
                    flex: true,
                    renderCell: (params) => (<Button onClick={() => openDeleteRow(params)}>
                        <DeleteRoundedIcon />
                    </Button>),
                },]}
                disableRowSelectionOnClick
                rows={rows}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: PAGE_DEFAULT_SIZE,
                        },
                    },
                }}
                sortingaOrder={['asc', 'desc']}
                localeText={localeBRDataGridText}
            />
        </Paper>

        <ConfirmDialog
            open={dialogDeleteFile.open}
            title={dialogDeleteFile.title}
            onConfirm={() => deleteFile()}
            onClose={() => setDialogDeleteFile({ ...dialogDeleteFile, open: false, file: null })}>
            <span>Essa ação não pode ser desfeita.</span>
        </ConfirmDialog>

        <UploadFileModalComponent
            open={modalUploadClose}
            onClose={setModalUploadClose}
            supportedTypes={MEDIA_FILE_TYPE}
            onSubmit={uploadFile} />

        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
            <DialogContent>
                {fileUrl && (<iframe
                    src={fileUrl}
                    style={{ width: '100%', height: '80vh', border: 'none' }}
                    title="Visualização do Documento"
                />)}
            </DialogContent>
        </Dialog>
    </>
}

DocumentosTableComponent.propTypes = {
    diretorio: PropTypes.string, pasta: PropTypes.string, callbackAlert: PropTypes.func, enableUpload: PropTypes.bool
}


export default DocumentosTableComponent